import {CHART_OPTIONS} from 'containers/cloud-billing/utils/utils';
import {diaryAreaChart, monthlyAreaChart, last12AreaChart, yearlyAreaChart} from 'containers/cloud-billing/config/config';

const SET_SELECTED_CHART = 'SET_SELECTED_CHART';

const CREATE_DAILY_CHART_CONFIG = 'CREATE_DAILY_CHART_CONFIG';
const CREATE_MONTHLY_CHART_CONFIG = 'CREATE_MONTHLY_CHART_CONFIG';
const CREATE_YEARLY_CHART_CONFIG = 'CREATE_YEARLY_CHART_CONFIG';
const CREATE_ANNUAL_CHART_CONFIG = 'CREATE_ANNUAL_CHART_CONFIG';

const SET_AGGREGATED = 'SET_AGGREGATED';

export const setSelectedChart = chart => ({
    type: SET_SELECTED_CHART,
    chart
});

export const setAggregated = aggregated => ({
    type: SET_AGGREGATED,
    aggregated
});

export const createDailyChartConfig = (series, categories) => ({
    type: CREATE_DAILY_CHART_CONFIG,
    series,
    categories
});

export const createAnnualChartConfig = (series, categories) => ({
    type: CREATE_ANNUAL_CHART_CONFIG,
    series,
    categories
});

export const createYearlyChartConfig = (series, categories) => ({
    type: CREATE_YEARLY_CHART_CONFIG,
    series,
    categories
});

const _defaultState = () => ({
    dailyChartConfig:   {},
    monthlyChartConfig: {},
    annualChartConfig:  {},
    yearlyChartConfig:  {},
    chart:              CHART_OPTIONS.DIARY
});


export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case SET_SELECTED_CHART:
        return {
            ...state,
            chart: action.chart
        };
    case SET_AGGREGATED:
        return {
            ...state,
            aggregated: action.aggregated
        };
    case CREATE_DAILY_CHART_CONFIG:
        return {
            ...state,
            dailyChartConfig: {
                ...diaryAreaChart,
                series: action.series
            }
        };
    case CREATE_MONTHLY_CHART_CONFIG:
        return {
            ...state,
            monthlyChartConfig: {
                ...monthlyAreaChart,
                series: action.series
            }
        };
    case CREATE_ANNUAL_CHART_CONFIG:
        return {
            ...state,
            annualChartConfig: {
                ...last12AreaChart,
                series: action.series,
                xAxis:  {
                    ...last12AreaChart.xAxis,
                    categories: action.categories
                }
            }
        };
    case CREATE_YEARLY_CHART_CONFIG:
        return {
            ...state,
            yearlyChartConfig: {
                ...yearlyAreaChart,
                series: action.series,
                xAxis:  {
                    ...yearlyAreaChart.xAxis,
                    categories: action.categories
                }
            }
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/cloudBillingCharts.js